if (document.querySelector('.faq-sec__container')) {
  const faqsContainersArr = document.querySelectorAll('.faq-sec__container');
  faqsContainersArr.forEach((faqsContainer) => {
    if (!faqsContainer.classList.contains('is-init-faq')) {
      faqsContainer.classList.add('is-init-faq');

      const togglesArr = faqsContainer.querySelectorAll('.faq-sec__toggle');
      const itemsArr = faqsContainer.querySelectorAll('.faq-sec__item');

      togglesArr.forEach((toggle, idx) => {
        toggle.addEventListener('click', () => {
          if (toggle.classList.contains('is-active')) {
            closeTabFunc(toggle, idx);
          } else {
            openTabFunc(toggle, idx);
          }
        });
      });

      function openTabFunc(toggle, idx) {
        for (let i = 0; i < togglesArr.length; i++) {
          togglesArr[i].classList.remove('is-active');
          itemsArr[i].classList.remove('is-active');
        }

        toggle.classList.add('is-active');
        itemsArr[idx].classList.add('is-active');
      }

      function closeTabFunc(toggle, idx) {
        toggle.classList.remove('is-active');
        itemsArr[idx].classList.remove('is-active');
      }
    }
  });
}
